import React, { createContext, useState, useContext, ReactNode } from 'react';

// Define the shape of your context
interface InputDataContextType {
  inputData: any[]; // Adjust 'any[]' to a more specific type if needed
  setInputData: React.Dispatch<React.SetStateAction<any[]>>; // Same here
}

// Create the context with the defined type
const InputDataContext = createContext<InputDataContextType | undefined>(undefined);

interface InputDataProviderProps {
  children: ReactNode;
}

export const InputDataProvider: React.FC<InputDataProviderProps> = ({ children }) => {
  const [inputData, setInputData] = useState<any[]>([]); // Replace 'any' with your data type if known

  return (
    <InputDataContext.Provider value={{ inputData, setInputData }}>
      {children}
    </InputDataContext.Provider>
  );
};

export const useInputData = (): InputDataContextType => {
  const context = useContext(InputDataContext);
  if (!context) {
    throw new Error('useInputData must be used within an InputDataProvider');
  }
  return context;
};
